module.exports = __webpack_public_path__ + "static/media/chisu.c4d5b77b.webp";